import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { testimonialSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import CodeEditor from "../../../Components/CodeEditor";

const AddTestimonial = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    sortOrder: editData?.sortOrder || "",
    name: editData?.name || "",
    description: editData?.description,
    rating: editData?.rating || "",
    date: editData?.date || "",
    isActive: editData?.isActive ?? true,
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: testimonialSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId ? await axiosInstance.put(`/testimonial/updatetestimonial/${editingId}`, values,
        ) : await axiosInstance.post("/testimonial/createtestimonial", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/testimonials");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Testimonials", path: "/testimonials" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Testimonial
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="testimonial-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="testimonial-sortOrder"
                        name="sortOrder"
                        placeholder="Enter testimonial Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="testimonial-name"
                        className="col-form-label "
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="testimonial-name"
                        name="name"
                        placeholder="Enter testimonial name"
                        value={values.name || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.name && errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="testimonial-date"
                        className="col-form-label "
                      >
                        Date
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control  `}
                        id="testimonial-date"
                        name="date"
                        placeholder="Enter testimonial date"
                        value={values.date || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.date && errors.date && (
                        <small className="text-danger">{errors.date}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="testimonial-rating"
                        className="col-form-label "
                      >
                        Rating
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="testimonial-rating"
                        name="rating"
                        placeholder="Enter testimonial rating"
                        value={values.rating || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.rating && errors.rating && (
                        <small className="text-danger">{errors.rating}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="subCategory-description"
                        className="col-form-label "
                      >
                        Description
                      </label>

                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />

                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-5">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/testimonials">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTestimonial;
